import { useMutation } from '@apollo/client';

import { TextInputLight } from 'components/site/layouts/DefaultPageLayout/TextInputLight';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import {
    SendResetLink,
    SendResetLinkVariables
} from 'libs/graphql/mutation/access/__generated__/SendResetLink';
import { SEND_RESET_LINK_MUTATION } from 'libs/graphql/mutation/access/accessMutation';
import { EShadows } from 'libs/styles/styling';
import { EToastType } from 'libs/types/site/IClient';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import { VALID_EMAIL_HASH } from 'libs/utils/validation/validation';
import { useState } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ForgottenPasswordForm = (props: Props): JSX.Element => {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);

    const [sendEmail] = useMutation<SendResetLink, SendResetLinkVariables>(
        SEND_RESET_LINK_MUTATION
    );

    function submit() {
        sendEmail({
            variables: {
                email
            },
            onCompleted: () => {
                setSent(true);
            },
            onError: (err) => {
                const r = err.message;
                if (r === 'USER_NOT_FOUND') {
                    userMessage(EToastType.ERROR, Localization.ERROR_SENT_LINK);
                } else {
                    userMessage(EToastType.ERROR, Localization.ERROR_SENT_LINK);
                }
            }
        });
    }

    const canSubmit = !!email.match(VALID_EMAIL_HASH);

    return (
        <S_ForgotPasswordForm className={props.className}>
            {!sent && (
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (canSubmit) {
                            submit();
                        }
                    }}
                >
                    <TextInputLight
                        value={email}
                        label={Localization.EMAIL}
                        type="email"
                        autoComplete="username"
                        autoFocus={true}
                        onChange={(value) => {
                            setEmail(value);
                        }}
                    />
                    <S_Center>
                        <S_WebButton
                            text={Localization.SEND_RESET_LINK_ACTION}
                            type="primary"
                            shadow={EShadows.LIGHT}
                            onClick={() => {
                                submit();
                            }}
                            disabled={!canSubmit}
                        />
                    </S_Center>
                </form>
            )}

            {sent && (
                <Message type="info">
                    An email with a recovery link was sent to your email address <b>{email}</b>..
                    Please check your inbox and spam folder
                </Message>
            )}
        </S_ForgotPasswordForm>
    );
};

const S_ForgotPasswordForm = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 7px;
`;

const S_Center = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0 0 0;
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 0 0 0px 0;
`;
